import { Component, HostBinding, OnInit } from '@angular/core';
import { ProjectService } from '../projects/project.service';
import { Project } from '../models/project';
import { WidgetService } from '../widgets/widget.service';
import { Widget } from '../models/widget';

@Component({
  selector: 'cw-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  @HostBinding('class') className = 'content-container';

  projects: Project[];
  widgets: Widget[];

  constructor(private projectService: ProjectService,
              private widgetService: WidgetService) {
  }

  ngOnInit() {
    this.projectService.getLatest().subscribe(projects => {
      this.projects = projects;
    });

    this.widgetService.getLatest().subscribe(widgets=> {
      this.widgets = widgets;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts